import React, {useEffect, useRef, useState} from "react";
import '../css/renderer.css';
import { Render, AnyItem, RenderOptions, Option, ErrorType, SubmitItem } from '@cfinnestad/react-form-builder'
import axios from "axios";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import SubmitButton from "./SubmitButton";
import GciTheme from "./GciTheme";
import GciDarkTheme from "./GciDarkTheme";

export type RendererProps = {
    formData: AnyItem[],
    submitUrl: string,
    citiesUrl: string,
    thankyouText: { html: string },
    csrfToken: string,
    recaptchaSiteKey: string,
    errors: ErrorType,
    theme: string,
}

const FormRenderer = ({ formData, submitUrl, citiesUrl, thankyouText, csrfToken, recaptchaSiteKey, errors, theme }: RendererProps) => {

    // Check if form has a Submit item in the schema. If not, add one.
    const needsSubmit = useRef(formData.filter(item => item.type === 'Submit').length === 0)
    const defaultSubmitItem = {
        type: 'Submit',
        id: 'submit1',
        label: 'Submit',
        submitElementName: 'default'
    } as SubmitItem

    const [formHeight, setFormHeight ] = useState(0)
    const [displayThankyou, setDisplayThankyou ] = useState(false)
    const [items, setItems] = useState(needsSubmit.current ? [...formData, defaultSubmitItem] : formData)

    // Broadcasting overall form height to parent elements.
    useEffect(() => {
        setInterval(() => {
            // setFormHeight($('.page').height())
            setFormHeight(document.documentElement.offsetHeight)

        }, 100)
    }, [])

    useEffect(() => {
        console.log('formHeight', formHeight)
        window.parent.postMessage(['setFormHeight', formHeight], '*')
    }, [formHeight])

    const serviceCitySearch = async (input?: string): Promise<Option[]> => {
        if (input == null || input.length < 2) {
            console.log('small input, skipping api call', input)
            return []
        }

        const response = await axios.get(
            citiesUrl,
            {
                params: {
                    term: input
                },
            })

        try {
            const options = response.data != null ? response.data.map( (city: string) => {
                return {
                    label: city,
                    value: city
                } as Option
            }) : []
            console.log('service city options', input, options)
            return options
        } catch (err) {
            console.error('error fetching service city options', err)
        }

        return []
    }

    const options: RenderOptions = {
        searchableOptions: {
            serviceCities: serviceCitySearch
        },
        submitElements: {
            'default': SubmitButton
        },
        muiTheme: theme === 'dark' ? GciDarkTheme : GciTheme,
        custom: {
            submitUrl: submitUrl,
            csrfToken: csrfToken,
            setDisplayThankyou: setDisplayThankyou,
        },
        Errors: errors,
    }

    if(!displayThankyou) {
        return <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
                <div className="page">
                    <Render Items={items} Options={options}></Render>
                </div>
        </GoogleReCaptchaProvider>
    } else {
        return <div
            className={theme === 'dark' ? "dark-mode" : ""}
            dangerouslySetInnerHTML={ { __html: thankyouText.html } }
        />
    }

}

export default FormRenderer
